import { Controller } from "@hotwired/stimulus"
import StimulusReflex from "stimulus_reflex"

 
export default class extends Controller {
  static values = {
 
    loadingText: { type: String, default: "Mise à jour…" }
  }

  connect() {
 
    StimulusReflex.register(this)

    // Fallback ultra-fiable : écoute des événements globaux (au cas où)
    this._beforeHandler  = (e) => { if (e.detail?.element === this.element) this.showSpinner() }
    this._finalHandler   = (e) => { if (e.detail?.element === this.element) this.hideSpinner() }
    document.addEventListener("stimulus-reflex:before", this._beforeHandler)
    document.addEventListener("stimulus-reflex:finalize", this._finalHandler)

    // Si l'élément a été re-render, on recrée/récupère le spinner
    this._ensureSpinner();

   

  }

  disconnect() {
    document.removeEventListener("stimulus-reflex:before", this._beforeHandler)
    document.removeEventListener("stimulus-reflex:finalize", this._finalHandler)
  }

  // Hooks StimulusReflex 3.x
  // (appelés automatiquement si ce contrôleur est sur l'élément déclencheur)
  beforeReflex(element) {
    if (element === this.element) this.showSpinner()
  }

  finalizeReflex(element) {
    
    if (element === this.element) this.hideSpinner();
        this.initializeSelect2ContentSearch();
        this.changeColor();
  }
   templateResult(item, container) {
      // replace the placeholder with the break-tag and put it into an jquery object
      return $("<span>" + item.text.replace("[br]", "<br/>") + "</span>");
    }

     templateSelection(item, container) {
      // replace your placeholder with nothing, so your select shows the whole option text
      return item.text.replace("[br]", "");
    }
     initializeSelect2ContentSearch() {
      const $select = $(".content-search");

      // Vérifie si l'élément existe et n'est pas déjà initialisé
      if ($select.length && !$select.hasClass("select2-hidden-accessible")) {
        const options = {
          width: "resolve",
          placeholder: "",
          allowClear: true,
          templateResult: this.templateResult,
          templateSelection: this.templateSelection,
        };

        // Gère le cas spécial où on ne veut pas fermer après sélection
        if ($select.hasClass("no-close-select")) {
          options.closeOnSelect = false;
        }

        $select.select2(options);

        // Événements à déclencher sur sélection et désélection
        $select.on("select2:select select2:unselect", function () {
          this.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
    }
  changeColor(event) {
    // console.log(`[ 🎨🎨 changeColor] called from ${this.identifier}`);

    function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? "rgb(" +
            parseInt(result[1], 16) +
            "," +
            parseInt(result[2], 16) +
            "," +
            parseInt(result[3], 16) +
            ")"
        : null;
    }
    if ($("#condition_change_color").val() == "true") {
      var newColor = $("#new_color_1").val();
      var oldColor = "#3fb0ac";
      var oldColor_bis = "#3eb0ac";
      var newColor2 = $("#new_color_1").val();
      var oldColor2 = "#1d5050";
      $("*").css("color", function (i, val) {
        val = val.replace(/\s/g, "");
        if (
          val == oldColor ||
          val == hexToRgb(oldColor) ||
          val.includes(oldColor) ||
          val.includes(hexToRgb(oldColor)) ||
          val == oldColor_bis ||
          val == hexToRgb(oldColor_bis) ||
          val.includes(oldColor_bis) ||
          val.includes(hexToRgb(oldColor_bis))
        ) {
          return newColor;
        } else if (
          val == oldColor2 ||
          val == hexToRgb(oldColor2) ||
          val.includes(oldColor2) ||
          val.includes(hexToRgb(oldColor2))
        ) {
          return newColor2;
        }
      });
      $("*").css("background", function (i, val) {
        val = val.replace(/\s/g, "");
        if (
          val == oldColor ||
          val == hexToRgb(oldColor) ||
          val.includes(oldColor) ||
          val.includes(hexToRgb(oldColor)) ||
          val == oldColor_bis ||
          val == hexToRgb(oldColor_bis) ||
          val.includes(oldColor_bis) ||
          val.includes(hexToRgb(oldColor_bis))
        ) {
          return newColor;
        } else if (
          val == oldColor2 ||
          val == hexToRgb(oldColor2) ||
          val.includes(oldColor2) ||
          val.includes(hexToRgb(oldColor2))
        ) {
          return newColor2;
        }
      });
      // Vérification si l'élément existe avant d'appliquer la modification
      const lastChild = $(
        ".fx-table-hm.fx-table-hm-wrapped tbody tr:last-child"
      );
      if (lastChild.length > 0) {
        lastChild.css("border-bottom", `4px solid ${newColor}`);
      }
    }
  }
  showSpinner() {
    this._ensureSpinner()
    this.spinner.style.display = "inline-block"
    this.spinner.setAttribute("title", this.loadingTextValue)
  
    this.spinner.setAttribute("aria-live", "polite")
  }

  hideSpinner() {
    if (this.spinner) this.spinner.style.display = "none"
  }

 
static values = {
  loadingText: { type: String, default: "Mise à jour…" },
  hostSelector: { type: String, default: "[data-reflex-loader-host], td.datas-fiche, .form-group, .field, td, .cell, .col, form" }
}

// ...

_showHost() {
 
  let start = this.element
  if (start.closest("label")) start = start.closest("label").parentElement || start.parentElement

 
  let host = start.closest(this.hostSelectorValue) || start.parentElement || document.body

   
  if (host && host.tagName === "LABEL") host = host.parentElement || document.body

  return host
}

_ensureSpinner() {
  if (this.spinner && document.body.contains(this.spinner)) return

  const baseId = this.element.id || this._uid()
  const id = baseId + "-spinner"

 
  let el = document.getElementById(id)

  if (!el) {
    el = document.createElement("i")
    el.id = id
    el.className = "fa fa-spinner fa-spin"
    el.style.display = "none"
    el.style.marginLeft = "6px"
    el.style.verticalAlign = "middle"
    el.style.position = "relative"
    el.style.zIndex = "1000"               
    el.style.pointerEvents = "none"        
    el.setAttribute("data-reflex-permanent", "true")
  }

  
  const host = this._showHost()
  if (el.parentElement !== host) {
    host.appendChild(el)                    
  }

  this.spinner = el
}


  _uid() {
 
    if (!this.__uid) {
      this.__uid = "rl-" + Math.random().toString(36).slice(2, 9)
    }
    return this.__uid
  }
}
